"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccordionElement = exports.AccordionHeading = exports.AccordionButton = exports.AccordionContent = exports.AccordionContentWrapper = exports.AccordionTitle = exports.AccordionItemWrapper = void 0;

var _get3 = _interopRequireDefault(require("lodash-es/get"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _heading = _interopRequireDefault(require("../../atoms/heading"));

var _button = _interopRequireDefault(require("../../atoms/button"));

var _versions = require("../../_utils/versions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject7() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  margin: 0;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  margin: auto 8px auto 16px;\n  &:focus {\n    outline: none;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  margin: 8px auto 24px 34px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  max-height: 0;\n  overflow: hidden;\n  transition: max-height 0.5s;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  min-height: 48px;\n  cursor: pointer;\n  &:hover {\n    background-color: ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  border-bottom: ", ";\n  &:first-child {\n    border-top: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var LOOKUP_NAME = 'accordion';

var colorHelper = function colorHelper(props, key) {
  return (0, _get3["default"])((0, _versions.getColor)(props, LOOKUP_NAME), key, '');
};

var getBorder = function getBorder(props) {
  return props.bordered ? "1px solid ".concat(colorHelper(props, 'itemBorderColor')) : 'none';
};

var AccordionItemWrapper = _styledComponents["default"].div(_templateObject(), getBorder, getBorder);

exports.AccordionItemWrapper = AccordionItemWrapper;

var AccordionTitle = _styledComponents["default"].label(_templateObject2(), function (props) {
  return colorHelper(props, 'itemHoverColor');
});

exports.AccordionTitle = AccordionTitle;

var AccordionContentWrapper = _styledComponents["default"].div(_templateObject3());

exports.AccordionContentWrapper = AccordionContentWrapper;

var AccordionContent = _styledComponents["default"].div(_templateObject4());

exports.AccordionContent = AccordionContent;
var AccordionButton = (0, _styledComponents["default"])(_button["default"])(_templateObject5());
exports.AccordionButton = AccordionButton;
var AccordionHeading = (0, _styledComponents["default"])(_heading["default"])(_templateObject6());
exports.AccordionHeading = AccordionHeading;

var AccordionElement = _styledComponents["default"].div(_templateObject7());

exports.AccordionElement = AccordionElement;